import {
  type ConfigurationFeaturesResponse,
  useGetConfigurationFeatures,
} from '@/api/REST/configuration-features';

export const useUserAccountHasFeature = <
  K extends keyof ConfigurationFeaturesResponse,
>(
  featureKey: K,
) => {
  const {
    data: configurationFeatures,
    isLoading,
    ...restProps
  } = useGetConfigurationFeatures();

  return {
    hasFeature: !!(configurationFeatures?.[
      featureKey
    ] as ConfigurationFeaturesResponse[K]),
    isLoading,
    ...restProps,
  };
};
